import React, { createContext, useContext, useState } from 'react'

const PendingOnDutyRequestContext = createContext();

export default function PendingOnDutyRequestProvider({ children }) {
    const [pendingOndutyCount, setPendingOnDutyCount] = useState(0);

    const updatePendingOndutyCount = (newCount) => {
    setPendingOnDutyCount(newCount);
  };

  return (
    <PendingOnDutyRequestContext.Provider value={{ pendingOndutyCount, updatePendingOndutyCount }}>
      {children}
    </PendingOnDutyRequestContext.Provider>
  )
}

export const usePendingOnDutyRequests = () => useContext(PendingOnDutyRequestContext);